module.exports = __webpack_public_path__ + "img/checked1.50a2711e.png";